import generalMixin from "./general";

// const mixins = {
// 	methods: {
// 		...generalMixin.methods
// 	}
// }

export default generalMixin;